import React, {useState, useRef, useEffect, createRef} from 'react';
import {Swiper, SwiperSlide} from 'swiper/react';
import {Navigation} from 'swiper';
import ArrowLeft from '../icon/ArrowLeft';
import {Title, TitleLevel, TitleSize} from '../Title';
import 'swiper/scss';
import 'swiper/scss/navigation';

import './FirstScreenSwiper.scss';

const DATA = [
  {
    name: 'Ремонт совмещённого санузла ',
    price: <>90&nbsp;000&nbsp;₽</>,
    area: '6м²',
    duration: '14 дней',
    poster: '/img/first-screen/image-1.png',
    video: '/video/first-screen/video-1.mp4',
  },
  {
    name: 'Ремонт совмещённого санузла ',
    price: <>247&nbsp;000&nbsp;₽</>,
    area: '5.5м²',
    duration: '30 дней',
    poster: '/img/first-screen/image-2.png',
    video: '/video/first-screen/video-2.mp4',
  },
];

const FirstScreenSwiper = () => {
  const swiperRef = useRef(null);
  const [currentIndex, setCurrentIndex] = useState(1);
  const videoRefs = [createRef(), createRef()];

  useEffect(() => {
    videoRefs[1]?.current?.pause();
  }, []);

  return (
    <div className="first-screen-swiper__wrapper">
      <Title
        extraClassName="first-screen-swiper__title"
        level={TitleLevel.H2}
        size={TitleSize.H2}
      >
        Наши работы
        <span className="first-screen-swiper__title-counter">
          {currentIndex}/{DATA.length}
        </span>
      </Title>

      <Swiper
        className="first-screen-swiper"
        ref={swiperRef}
        modules={[Navigation]}
        spaceBetween={4}
        slidesPerView={1}
        onSlideChange={swiper => {
          setCurrentIndex(swiper.activeIndex + 1);
          videoRefs[(swiper.activeIndex + 1) % 2]?.current?.pause();
          videoRefs[swiper.activeIndex]?.current?.play();
        }}
        initialSlide={0}
      >
        <SwiperSlide className="first-screen-swiper__slide">
          <video
            loop
            autoPlay
            muted
            playsInline
            poster="/img/first-screen/image-1.png"
            ref={videoRefs[0]}
          >
            <source src="/video/first-screen/video-1.mp4" />
          </video>

          <div className="first-screen-swiper__slide-info">
            <p className="first-screen-swiper__slide-title">{DATA[0].name}</p>

            <div className="first-screen-swiper__slide-price">
              {DATA[0].price}&nbsp;&nbsp;•&nbsp;&nbsp;{DATA[0].area}
              &nbsp;&nbsp;•&nbsp;&nbsp;{DATA[0].duration}
            </div>
          </div>
        </SwiperSlide>

        <SwiperSlide className="first-screen-swiper__slide">
          <video
            loop
            autoPlay
            muted
            playsInline
            poster="/img/first-screen/image-2.png"
            ref={videoRefs[1]}
          >
            <source src="/video/first-screen/video-2.mp4" />
          </video>

          <div className="first-screen-swiper__slide-info">
            <p className="first-screen-swiper__slide-title">{DATA[1].name}</p>

            <div className="first-screen-swiper__slide-price">
              {DATA[1].price}&nbsp;&nbsp;•&nbsp;&nbsp;{DATA[1].area}
              &nbsp;&nbsp;•&nbsp;&nbsp;{DATA[1].duration}
            </div>
          </div>
        </SwiperSlide>
      </Swiper>

      <div className="first-screen-swiper__controls">
        <ArrowLeft
          extraClassName="first-screen-swiper__arrow"
          color={currentIndex === 1 ? '#333' : '#fff'}
          onClick={() => {
            if (!swiperRef) {
              return;
            }

            swiperRef.current.swiper.slidePrev();
          }}
        />

        <span className="first-screen-swiper__controls-counter">
          {currentIndex}/{DATA.length}
        </span>

        <ArrowLeft
          extraClassName="first-screen-swiper__arrow first-screen-swiper__arrow_right"
          color={currentIndex === 2 ? '#333' : '#fff'}
          onClick={() => {
            if (!swiperRef) {
              return;
            }

            swiperRef.current.swiper.slideNext();
          }}
        />
      </div>
    </div>
  );
};

export default FirstScreenSwiper;
